import React, { FC, useEffect, useRef, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { getSectionByID } from "../../Tools/Tools";
import { useAtomValue, useSetAtom } from "jotai";
import { sectionListAtom, selectedSectionAtom, setSelectedSectionAtom } from "../../../../atoms";
import { SectionsList, SelectedSection } from "../SideBar/SideBarInterface";

const LinkBreadcrumb: FC<{
  name?: string;
  id?: number;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}> = ({ name = "", id = 0, onClick = null }) => (
  <Link
    underline="hover"
    color="inherit"
    href="#"
    idsec={id}
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    {name}
  </Link>
);

// Функция для глубокого поиска выбранной секции и сбора цепочки
export function getSectionChain(
  sections: SectionsList[],
  selectedSection: SelectedSection,
): (SectionsList | any)[] | null {
  function findChain(sections: SectionsList[], targetId: string): SectionsList[] | null {
    return sections.reduce<SectionsList[] | null>((acc, section) => {
      if (acc !== null) return acc;
      if (section.ID === targetId) {
        return [section];
      }
      if (section.Sections) {
        const sub = findChain(section.Sections, targetId);
        if (sub) {
          return [section, ...sub];
        }
      }
      return null;
    }, null);
  }

  let chain = findChain(sections, selectedSection.ID);
  if (chain && selectedSection.Selected && selectedSection.Selected.Name) {
    chain = [...chain, { Name: selectedSection.Selected.Name, ...selectedSection.Selected } as SectionsList];
  }
  return chain;
}

//eslint-disable-next-line
const SmetaBreadcrumbs: FC = () => {
  const sideBarSelected = useAtomValue(selectedSectionAtom);
  const sideBarData = useAtomValue(sectionListAtom);
  const [links, setLinks] = useState<(SectionsList | any)[]>([]);
  const setSelectedSection = useSetAtom(setSelectedSectionAtom);
  const breadcrumbsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sideBarSelected.ID !== "" && sideBarData) {
      const chain = getSectionChain(sideBarData, sideBarSelected);
      setLinks(chain || []);
    }
  }, [sideBarSelected.ID, sideBarSelected.Selected]);

  function сlearBreadCrumbs() {
    if (breadcrumbsRef.current) {
      for (const value of Object.values(breadcrumbsRef.current.firstChild?.children || {})) {
        if ((value as HTMLElement).id === "noneBreadcrumbs") (value as HTMLElement).remove();
      }
    }
  }

  function onClickLink(item: SectionsList) {
    const id = item.ID;
    сlearBreadCrumbs();
    if (id !== sideBarSelected.ID) {
      setSelectedSection(getSectionByID(id));
    }
  }

  return (
    <Stack spacing={1}>
      <Breadcrumbs
        ref={breadcrumbsRef}
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ color: "inherit" }}
        id={"BreadcrumbsSelected"}
      >
        {links.length > 0 ? (
          links.map((link, index) => (
            <LinkBreadcrumb name={link.Name} key={index} id={link.ID} onClick={() => onClickLink(link)} />
          ))
        ) : (
          <span id="noneBreadcrumbs"></span>
        )}
      </Breadcrumbs>
    </Stack>
  );
};

export default SmetaBreadcrumbs;
